import { render, staticRenderFns } from "./MiniAppRealtime.vue?vue&type=template&id=594c2999&scoped=true"
import script from "./MiniAppRealtime.vue?vue&type=script&lang=js"
export * from "./MiniAppRealtime.vue?vue&type=script&lang=js"
import style0 from "./MiniAppRealtime.vue?vue&type=style&index=0&id=594c2999&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594c2999",
  null
  
)

export default component.exports